// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Medications-module__font-s-10___I5Ed9 {
  font-size: 10px !important;
}

.Medications-module__font-s-12___mbnUQ {
  font-size: 12px !important;
}

.Medications-module__font-s-13___UW5s2 {
  font-size: 13px !important;
}

.Medications-module__font-s-14___S4o1t {
  font-size: 14px !important;
}

.Medications-module__font-s-15___H5n5D {
  font-size: 15px !important;
}

.Medications-module__font-s-16___kmigv {
  font-size: 16px !important;
}

.Medications-module__font-s-18___awBC7 {
  font-size: 18px !important;
}

.Medications-module__font-s-20___wuSsQ {
  font-size: 20px !important;
}

.Medications-module__font-s-22___SNsKj {
  font-size: 22px !important;
}

.Medications-module__font-s-28___lbHQc {
  font-size: 28px !important;
}

.Medications-module__font-w-400___j5aiC {
  font-weight: 400 !important;
}

.Medications-module__font-w-500____nvTc {
  font-weight: 500 !important;
}

.Medications-module__font-w-600___DIjA4 {
  font-weight: 600 !important;
}

.Medications-module__font-w-700___FQugU {
  font-weight: 700 !important;
}

.Medications-module__p-5___BIZYn {
  padding: 5px !important;
}

.Medications-module__p-12___igENn {
  padding: 12px !important;
}

.Medications-module__p-16___QwJK3 {
  padding: 16px !important;
}

.Medications-module__p-30___gNxPn {
  padding: 30px !important;
}

.Medications-module__p-b-0___F04xG {
  padding-bottom: 0 !important;
}

.Medications-module__p-b-5___PRr6S {
  padding-bottom: 5px !important;
}

.Medications-module__p-b-10___P6oZk {
  padding-bottom: 10px !important;
}

.Medications-module__p-b-12___t22kF {
  padding-bottom: 12px !important;
}

.Medications-module__p-b-16___CLqSm {
  padding-bottom: 16px !important;
}

.Medications-module__p-b-18___oPpY6 {
  padding-bottom: 18px !important;
}

.Medications-module__p-b-20___JX77f {
  padding-bottom: 20px !important;
}

.Medications-module__p-b-25___BSuu0 {
  padding-bottom: 25px !important;
}

.Medications-module__p-b-30___CPdQQ {
  padding-bottom: 30px !important;
}

.Medications-module__p-b-50___euPkS {
  padding-bottom: 50px !important;
}

.Medications-module__p-t-0___Jnufl {
  padding-top: 0 !important;
}

.Medications-module__p-t-12___G0HbE {
  padding-top: 12px !important;
}

.Medications-module__p-t-16___R9lKl {
  padding-top: 16px !important;
}

.Medications-module__p-t-18___leWaT {
  padding-top: 18px !important;
}

.Medications-module__p-t-20____6WKu {
  padding-top: 20px !important;
}

.Medications-module__p-t-30___IdeEi {
  padding-top: 30px !important;
}

.Medications-module__p-t-40___yDdJu {
  padding-top: 40px !important;
}

.Medications-module__p-t-50___emcO0 {
  padding-top: 50px !important;
}

.Medications-module__p-l-20___fNA1g {
  padding-left: 20px !important;
}

.Medications-module__p-l-30___f0_YJ {
  padding-left: 30px !important;
}

.Medications-module__p-l-40___Foyrk {
  padding-left: 40px !important;
}

.Medications-module__p-r-16___VHVtQ {
  padding-right: 16px !important;
}

.Medications-module__p-r-20___w8j0o {
  padding-right: 20px !important;
}

.Medications-module__p-r-30___an0yh {
  padding-right: 30px !important;
}

.Medications-module__p-r-50___sJ2Ku {
  padding-right: 50px !important;
}

.Medications-module__p-r-60___J2us0 {
  padding-right: 60px !important;
}

.Medications-module__m-b-1___bQOAJ {
  margin-bottom: 1px !important;
}

.Medications-module__m-b-2___DkGfh {
  margin-bottom: 2px !important;
}

.Medications-module__m-b-6___PJ3dR {
  margin-bottom: 6px !important;
}

.Medications-module__m-b-8___dFOHf {
  margin-bottom: 8px !important;
}

.Medications-module__m-b-10___JtI3y {
  margin-bottom: 10px !important;
}

.Medications-module__m-b-14___ImvMs {
  margin-bottom: 14px !important;
}

.Medications-module__m-b-16___MYtTy {
  margin-bottom: 16px !important;
}

.Medications-module__m-b-20___RP3Po {
  margin-bottom: 20px !important;
}

.Medications-module__m-b-22___Kbd_M {
  margin-bottom: 22px !important;
}

.Medications-module__m-b-24___DJmuP {
  margin-bottom: 24px !important;
}

.Medications-module__m-b-30___Yu7mE {
  margin-bottom: 30px !important;
}

.Medications-module__m-b-32___IzerP {
  margin-bottom: 32px !important;
}

.Medications-module__m-b-40___FJFdq {
  margin-bottom: 40px !important;
}

.Medications-module__m-t-2___IBiSU {
  margin-top: 2px !important;
}

.Medications-module__m-t-3___kFPcp {
  margin-top: 3px !important;
}

.Medications-module__m-t-4___aDd9I {
  margin-top: 4px !important;
}

.Medications-module__m-t-5___rZcOp {
  margin-top: 5px !important;
}

.Medications-module__m-t-8___AKARU {
  margin-top: 8px !important;
}

.Medications-module__m-t-10___h5TPG {
  margin-top: 10px !important;
}

.Medications-module__m-t-15___MMtsN {
  margin-top: 15px !important;
}

.Medications-module__m-t-16___RfTL2 {
  margin-top: 16px !important;
}

.Medications-module__m-t-20___ucOIq {
  margin-top: 20px !important;
}

.Medications-module__m-t-22___cxn_L {
  margin-top: 22px !important;
}

.Medications-module__m-t-30___PUkRu {
  margin-top: 30px !important;
}

.Medications-module__m-t-32___YBu4P {
  margin-top: 32px !important;
}

.Medications-module__m-l-auto___EGaNU {
  margin-left: auto !important;
}

.Medications-module__m-l-4___Wzllb {
  margin-left: 4px !important;
}

.Medications-module__m-l-5___j8zhq {
  margin-left: 5px !important;
}

.Medications-module__m-l-6___JgCeb {
  margin-left: 6px !important;
}

.Medications-module__m-l-8___ttN_8 {
  margin-left: 8px !important;
}

.Medications-module__m-l-10___vmULT {
  margin-left: 10px !important;
}

.Medications-module__m-l-16___Y4shj {
  margin-left: 16px !important;
}

.Medications-module__m-l-20___RBMDL {
  margin-left: 20px !important;
}

.Medications-module__m-l-24___hWPeD {
  margin-left: 24px !important;
}

.Medications-module__m-l-30___nvLlh {
  margin-left: 30px !important;
}

.Medications-module__m-l-35___PY2I5 {
  margin-left: 35px !important;
}

.Medications-module__m-l-40___Ow2GX {
  margin-left: 40px !important;
}

.Medications-module__m-r-8___FSaRL {
  margin-right: 8px !important;
}

.Medications-module__m-r-10___vTJYf {
  margin-right: 10px !important;
}

.Medications-module__m-r-16___TKXkn {
  margin-right: 16px !important;
}

.Medications-module__m-r-20___hcpQ6 {
  margin-right: 20px !important;
}

.Medications-module__m-r-24___BzF5t {
  margin-right: 24px !important;
}

.Medications-module__m-r-30___W9JlX {
  margin-right: 30px !important;
}

.Medications-module__m-r-40___dux0c {
  margin-right: 40px !important;
}

.Medications-module__border-r-3___X9MzU {
  border-radius: 3px !important;
}

.Medications-module__border-r-4___Tgu8f {
  border-radius: 4px !important;
}

.Medications-module__border-r-6___Qto4z {
  border-radius: 6px !important;
}

.Medications-module__border-r-10___KR4Qb {
  border-radius: 10px !important;
}

.Medications-module__border-r-12___hj2jf {
  border-radius: 12px !important;
}

.Medications-module__border-r-16___Hy8em {
  border-radius: 16px !important;
}

.Medications-module__border-r-50___W5riO {
  border-radius: 50% !important;
}

.Medications-module__primary-border___VJyjj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-b___s_ZaA {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-t___Sac_C {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-l___TGKXf {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-r___tJt2k {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__secondary-border___HmDSH {
  border: 1px solid #637768;
}

.Medications-module__secondary-border-b___zv2jo {
  border-bottom: 1px solid #637768;
}

.Medications-module__secondary-border-t___VrsVO {
  border-top: 1px solid #637768;
}

.Medications-module__secondary-border-l___TzE5d {
  border-left: 1px solid #637768;
}

.Medications-module__secondary-border-r___gwEuw {
  border-right: 1px solid #637768;
}

.Medications-module__gap-0___Vy2oN {
  gap: 0 !important;
}

.Medications-module__gap-2___G8KIm {
  gap: 2px !important;
}

.Medications-module__gap-4___knfvb {
  gap: 4px !important;
}

.Medications-module__gap-5___gtwKt {
  gap: 5px !important;
}

.Medications-module__gap-6___VmdHq {
  gap: 6px !important;
}

.Medications-module__gap-8___LXq8E {
  gap: 8px !important;
}

.Medications-module__gap-10___niDUo {
  gap: 10px !important;
}

.Medications-module__gap-12___EMDL9 {
  gap: 12px !important;
}

.Medications-module__gap-14___zFiyO {
  gap: 14px !important;
}

.Medications-module__gap-16___feyef {
  gap: 16px !important;
}

.Medications-module__gap-18___G7azZ {
  gap: 18px !important;
}

.Medications-module__gap-20___y60K6 {
  gap: 20px !important;
}

.Medications-module__gap-24___R3GNq {
  gap: 24px !important;
}

.Medications-module__gap-26___zSC_C {
  gap: 26px !important;
}

.Medications-module__gap-30___TNX8l {
  gap: 30px !important;
}

.Medications-module__gap-32___aW5WH {
  gap: 32px !important;
}

.Medications-module__gap-40___WQGTl {
  gap: 40px !important;
}

.Medications-module__gap-50___kfJ7W {
  gap: 50px !important;
}

.Medications-module__flex-1___sF1Z7 {
  flex: 1;
}

.Medications-module__flex-none___P22MP {
  flex: none !important;
}

.Medications-module__flex-column___IZPpC {
  display: flex;
  flex-direction: column !important;
}

.Medications-module__flex-row___Fy08j {
  display: flex;
  flex-direction: row !important;
}

.Medications-module__vertically-centered___Ltlxz {
  display: flex;
  align-items: center !important;
}

.Medications-module__horizontally-centered___kcudV {
  display: flex;
  justify-content: center !important;
}

.Medications-module__horizontally-end___WIwcK {
  display: flex;
  justify-content: end !important;
}

.Medications-module__vertically-start___Ifz7E {
  display: flex;
  align-items: start !important;
}

.Medications-module__space-between___OGKvX {
  display: flex;
  justify-content: space-between !important;
}

.Medications-module__flex-wrap___C_1YX {
  flex-wrap: wrap !important;
}

.Medications-module__height-100____HL8g {
  height: 100%;
}

.Medications-module__width-50___uneMB {
  width: 50% !important;
}

.Medications-module__width-100___zGD_m {
  width: 100%;
}

.Medications-module__cursor-pointer___PAF0h {
  cursor: pointer;
}

.Medications-module__cursor-not-allowed___EZGm8 {
  cursor: not-allowed !important;
}

.Medications-module__absolute-centered___Rm5Vx {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Medications-module__absolute___ZdovE {
  position: absolute;
}

.Medications-module__relative___W75Ph {
  position: relative;
}

.Medications-module__fixed___UkYrA {
  position: fixed;
}

.Medications-module__visible___PBwTd {
  opacity: 1;
}

.Medications-module__invisible___CqBN6 {
  opacity: 0;
}

.Medications-module__col-90___FLYHP {
  width: 90% !important;
}

.Medications-module__col-auto___QAYY1 {
  width: auto !important;
}

.Medications-module__medical-tabs___ohj_7 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Medications-module__medical-table-new___sOVFF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Medications-module__medical-table-new___sOVFF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Medications-module__medical-table-new___sOVFF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Medications-module__medical-table-new___sOVFF::-webkit-scrollbar-track {
  display: none;
}
.Medications-module__medical-table-new___sOVFF.Medications-module__no-pagination___qEp_h {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Medications-module__medical-table-new___sOVFF.Medications-module__no-pagination___qEp_h:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Medications-module__medical-table-new___sOVFF.Medications-module__no-pagination___qEp_h::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Medications-module__medical-table-new___sOVFF.Medications-module__no-pagination___qEp_h::-webkit-scrollbar-track {
  display: none;
}

.Medications-module__medical-table-empty___GfNB6 {
  padding: 14px 40px !important;
}

.Medications-module__icon-btn___UyAVe {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Medications-module__search-icon___z9Wph {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Medications-module__disable-select___PO8nw {
  user-select: none;
}

.Medications-module__break-word___VXuTd {
  word-break: break-word;
}

.Medications-module__popup-clear-btn___SCMDq {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Medications-module__scroll-m-b-20___rVxBS {
  scroll-margin-bottom: 20px;
}

.Medications-module__lastImported___ecudp {
  font-family: var(--font-family);
  font-weight: 400;
  font-weight: 500;
  color: #637768;
  flex: 1;
  justify-content: end;
  margin-right: 27px;
}

.Medications-module__pagination___uyIDw {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.Medications-module__rightContent___TSJQG {
  margin: -8px 0 8px 0;
}
.Medications-module__rightContent___TSJQG .Medications-module__button___WBESf {
  height: 38px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Medications/Medications.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBAFmD;EFrBnD,gBAAA;EACA,cAAA;EACA,OAAA;EACA,oBAAA;EACA,kBAAA;AA+pBF;;AA5pBA;EACE,wBAAA;EACA,2BAAA;AA+pBF;;AA5pBA;EACE,oBAAA;AA+pBF;AA7pBE;EACE,YAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.lastImported {\n  @include get-font();\n  font-weight: 500;\n  color: get-color(greenNew, medium-dark);\n  flex: 1;\n  justify-content: end;\n  margin-right: 27px;\n}\n\n.pagination {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.rightContent {\n  margin: -8px 0 8px 0;\n\n  .button {\n    height: 38px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Medications-module__font-s-10___I5Ed9`,
	"fontS12": `Medications-module__font-s-12___mbnUQ`,
	"fontS13": `Medications-module__font-s-13___UW5s2`,
	"fontS14": `Medications-module__font-s-14___S4o1t`,
	"fontS15": `Medications-module__font-s-15___H5n5D`,
	"fontS16": `Medications-module__font-s-16___kmigv`,
	"fontS18": `Medications-module__font-s-18___awBC7`,
	"fontS20": `Medications-module__font-s-20___wuSsQ`,
	"fontS22": `Medications-module__font-s-22___SNsKj`,
	"fontS28": `Medications-module__font-s-28___lbHQc`,
	"fontW400": `Medications-module__font-w-400___j5aiC`,
	"fontW500": `Medications-module__font-w-500____nvTc`,
	"fontW600": `Medications-module__font-w-600___DIjA4`,
	"fontW700": `Medications-module__font-w-700___FQugU`,
	"p5": `Medications-module__p-5___BIZYn`,
	"p12": `Medications-module__p-12___igENn`,
	"p16": `Medications-module__p-16___QwJK3`,
	"p30": `Medications-module__p-30___gNxPn`,
	"pB0": `Medications-module__p-b-0___F04xG`,
	"pB5": `Medications-module__p-b-5___PRr6S`,
	"pB10": `Medications-module__p-b-10___P6oZk`,
	"pB12": `Medications-module__p-b-12___t22kF`,
	"pB16": `Medications-module__p-b-16___CLqSm`,
	"pB18": `Medications-module__p-b-18___oPpY6`,
	"pB20": `Medications-module__p-b-20___JX77f`,
	"pB25": `Medications-module__p-b-25___BSuu0`,
	"pB30": `Medications-module__p-b-30___CPdQQ`,
	"pB50": `Medications-module__p-b-50___euPkS`,
	"pT0": `Medications-module__p-t-0___Jnufl`,
	"pT12": `Medications-module__p-t-12___G0HbE`,
	"pT16": `Medications-module__p-t-16___R9lKl`,
	"pT18": `Medications-module__p-t-18___leWaT`,
	"pT20": `Medications-module__p-t-20____6WKu`,
	"pT30": `Medications-module__p-t-30___IdeEi`,
	"pT40": `Medications-module__p-t-40___yDdJu`,
	"pT50": `Medications-module__p-t-50___emcO0`,
	"pL20": `Medications-module__p-l-20___fNA1g`,
	"pL30": `Medications-module__p-l-30___f0_YJ`,
	"pL40": `Medications-module__p-l-40___Foyrk`,
	"pR16": `Medications-module__p-r-16___VHVtQ`,
	"pR20": `Medications-module__p-r-20___w8j0o`,
	"pR30": `Medications-module__p-r-30___an0yh`,
	"pR50": `Medications-module__p-r-50___sJ2Ku`,
	"pR60": `Medications-module__p-r-60___J2us0`,
	"mB1": `Medications-module__m-b-1___bQOAJ`,
	"mB2": `Medications-module__m-b-2___DkGfh`,
	"mB6": `Medications-module__m-b-6___PJ3dR`,
	"mB8": `Medications-module__m-b-8___dFOHf`,
	"mB10": `Medications-module__m-b-10___JtI3y`,
	"mB14": `Medications-module__m-b-14___ImvMs`,
	"mB16": `Medications-module__m-b-16___MYtTy`,
	"mB20": `Medications-module__m-b-20___RP3Po`,
	"mB22": `Medications-module__m-b-22___Kbd_M`,
	"mB24": `Medications-module__m-b-24___DJmuP`,
	"mB30": `Medications-module__m-b-30___Yu7mE`,
	"mB32": `Medications-module__m-b-32___IzerP`,
	"mB40": `Medications-module__m-b-40___FJFdq`,
	"mT2": `Medications-module__m-t-2___IBiSU`,
	"mT3": `Medications-module__m-t-3___kFPcp`,
	"mT4": `Medications-module__m-t-4___aDd9I`,
	"mT5": `Medications-module__m-t-5___rZcOp`,
	"mT8": `Medications-module__m-t-8___AKARU`,
	"mT10": `Medications-module__m-t-10___h5TPG`,
	"mT15": `Medications-module__m-t-15___MMtsN`,
	"mT16": `Medications-module__m-t-16___RfTL2`,
	"mT20": `Medications-module__m-t-20___ucOIq`,
	"mT22": `Medications-module__m-t-22___cxn_L`,
	"mT30": `Medications-module__m-t-30___PUkRu`,
	"mT32": `Medications-module__m-t-32___YBu4P`,
	"mLAuto": `Medications-module__m-l-auto___EGaNU`,
	"mL4": `Medications-module__m-l-4___Wzllb`,
	"mL5": `Medications-module__m-l-5___j8zhq`,
	"mL6": `Medications-module__m-l-6___JgCeb`,
	"mL8": `Medications-module__m-l-8___ttN_8`,
	"mL10": `Medications-module__m-l-10___vmULT`,
	"mL16": `Medications-module__m-l-16___Y4shj`,
	"mL20": `Medications-module__m-l-20___RBMDL`,
	"mL24": `Medications-module__m-l-24___hWPeD`,
	"mL30": `Medications-module__m-l-30___nvLlh`,
	"mL35": `Medications-module__m-l-35___PY2I5`,
	"mL40": `Medications-module__m-l-40___Ow2GX`,
	"mR8": `Medications-module__m-r-8___FSaRL`,
	"mR10": `Medications-module__m-r-10___vTJYf`,
	"mR16": `Medications-module__m-r-16___TKXkn`,
	"mR20": `Medications-module__m-r-20___hcpQ6`,
	"mR24": `Medications-module__m-r-24___BzF5t`,
	"mR30": `Medications-module__m-r-30___W9JlX`,
	"mR40": `Medications-module__m-r-40___dux0c`,
	"borderR3": `Medications-module__border-r-3___X9MzU`,
	"borderR4": `Medications-module__border-r-4___Tgu8f`,
	"borderR6": `Medications-module__border-r-6___Qto4z`,
	"borderR10": `Medications-module__border-r-10___KR4Qb`,
	"borderR12": `Medications-module__border-r-12___hj2jf`,
	"borderR16": `Medications-module__border-r-16___Hy8em`,
	"borderR50": `Medications-module__border-r-50___W5riO`,
	"primaryBorder": `Medications-module__primary-border___VJyjj`,
	"primaryBorderB": `Medications-module__primary-border-b___s_ZaA`,
	"primaryBorderT": `Medications-module__primary-border-t___Sac_C`,
	"primaryBorderL": `Medications-module__primary-border-l___TGKXf`,
	"primaryBorderR": `Medications-module__primary-border-r___tJt2k`,
	"secondaryBorder": `Medications-module__secondary-border___HmDSH`,
	"secondaryBorderB": `Medications-module__secondary-border-b___zv2jo`,
	"secondaryBorderT": `Medications-module__secondary-border-t___VrsVO`,
	"secondaryBorderL": `Medications-module__secondary-border-l___TzE5d`,
	"secondaryBorderR": `Medications-module__secondary-border-r___gwEuw`,
	"gap0": `Medications-module__gap-0___Vy2oN`,
	"gap2": `Medications-module__gap-2___G8KIm`,
	"gap4": `Medications-module__gap-4___knfvb`,
	"gap5": `Medications-module__gap-5___gtwKt`,
	"gap6": `Medications-module__gap-6___VmdHq`,
	"gap8": `Medications-module__gap-8___LXq8E`,
	"gap10": `Medications-module__gap-10___niDUo`,
	"gap12": `Medications-module__gap-12___EMDL9`,
	"gap14": `Medications-module__gap-14___zFiyO`,
	"gap16": `Medications-module__gap-16___feyef`,
	"gap18": `Medications-module__gap-18___G7azZ`,
	"gap20": `Medications-module__gap-20___y60K6`,
	"gap24": `Medications-module__gap-24___R3GNq`,
	"gap26": `Medications-module__gap-26___zSC_C`,
	"gap30": `Medications-module__gap-30___TNX8l`,
	"gap32": `Medications-module__gap-32___aW5WH`,
	"gap40": `Medications-module__gap-40___WQGTl`,
	"gap50": `Medications-module__gap-50___kfJ7W`,
	"flex1": `Medications-module__flex-1___sF1Z7`,
	"flexNone": `Medications-module__flex-none___P22MP`,
	"flexColumn": `Medications-module__flex-column___IZPpC`,
	"flexRow": `Medications-module__flex-row___Fy08j`,
	"verticallyCentered": `Medications-module__vertically-centered___Ltlxz`,
	"horizontallyCentered": `Medications-module__horizontally-centered___kcudV`,
	"horizontallyEnd": `Medications-module__horizontally-end___WIwcK`,
	"verticallyStart": `Medications-module__vertically-start___Ifz7E`,
	"spaceBetween": `Medications-module__space-between___OGKvX`,
	"flexWrap": `Medications-module__flex-wrap___C_1YX`,
	"height100": `Medications-module__height-100____HL8g`,
	"width50": `Medications-module__width-50___uneMB`,
	"width100": `Medications-module__width-100___zGD_m`,
	"cursorPointer": `Medications-module__cursor-pointer___PAF0h`,
	"cursorNotAllowed": `Medications-module__cursor-not-allowed___EZGm8`,
	"absoluteCentered": `Medications-module__absolute-centered___Rm5Vx`,
	"absolute": `Medications-module__absolute___ZdovE`,
	"relative": `Medications-module__relative___W75Ph`,
	"fixed": `Medications-module__fixed___UkYrA`,
	"visible": `Medications-module__visible___PBwTd`,
	"invisible": `Medications-module__invisible___CqBN6`,
	"col90": `Medications-module__col-90___FLYHP`,
	"colAuto": `Medications-module__col-auto___QAYY1`,
	"medicalTabs": `Medications-module__medical-tabs___ohj_7`,
	"medicalTableNew": `Medications-module__medical-table-new___sOVFF`,
	"noPagination": `Medications-module__no-pagination___qEp_h`,
	"medicalTableEmpty": `Medications-module__medical-table-empty___GfNB6`,
	"iconBtn": `Medications-module__icon-btn___UyAVe`,
	"searchIcon": `Medications-module__search-icon___z9Wph`,
	"disableSelect": `Medications-module__disable-select___PO8nw`,
	"breakWord": `Medications-module__break-word___VXuTd`,
	"popupClearBtn": `Medications-module__popup-clear-btn___SCMDq`,
	"scrollMB20": `Medications-module__scroll-m-b-20___rVxBS`,
	"lastImported": `Medications-module__lastImported___ecudp`,
	"pagination": `Medications-module__pagination___uyIDw`,
	"rightContent": `Medications-module__rightContent___TSJQG`,
	"button": `Medications-module__button___WBESf`
};
module.exports = ___CSS_LOADER_EXPORT___;
